<template>
  <div>
    <b-row>
      <b-col class="col-md-2">
        <AppSearchInput
          :label="$t('search') + ':'"
          :placeholder="$t('search') + '...'"
          @callback="search"
        />
      </b-col>
    </b-row>

    <b-table
      id="user-table"
      class="px-1 rounded mt-1"
      :fields="fields"
      :items="GET_WAREHOUSE.results"
      show-empty
      responsive
      :empty-text="$t('empty_text')"
      :tbody-tr-class="['tableRowClass']"
      @row-clicked="onRowClicked"
    >
      <template #head()="props">
        <span>{{ $t(props.label) }}</span>
      </template>

      <template #cell(is_object)="props">
        <span>{{ props.item.is_object ? 'Главный' : 'Дочерний' }}</span>
      </template>

      <template #cell(actions)="data">
        <b-button
          size="sm"
          variant="success"
          class="mt-50 mb-50"
          @click="$router.push(`/objects/view-warehouse/${data.item.id}`)"
        >
          <feather-icon
            icon="ChevronsRightIcon"
            size="15"
          />
        </b-button>
      </template>
    </b-table>

    <Pagination
      :rows="GET_WAREHOUSE.count"
      @refresh="FETCH_WAREHOUSE"
    />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTable,
  BButton,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import AppSearchInput from '@/components/AppSearchInput.vue'
import Pagination from '@/components/Pagination.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BButton,
    AppSearchInput,
    Pagination,
  },
  data() {
    return {
      filter: {
        is_object: 1,
        search: null,
        object: null,
        storage: null,
      },
      type: [
        {
          value: true,
          title: 'Главный',
        },
        {
          value: false,
          title: 'Дочерний',
        },
      ],
      option: [],
      fields: [
        {
          label: '№',
          key: 'id',
          thClass: 'tableHeadClass',
        },
        {
          label: 'objects__ob',
          key: 'object.title',
          thClass: 'tableHeadClass',
        },
        {
          label: 'warehouse_type',
          key: 'is_object',
          thClass: 'tableHeadClass',
        },
        {
          label: 'warehouses',
          key: 'title',
          thClass: 'tableHeadClass',
        },
        {
          label: 'actions',
          key: 'actions',
          thClass: 'tableHeadClass',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('obectsWarehouse', ['GET_OBECTS', 'GET_WAREHOUSE']),
  },
  mounted() {
    this.FETCH_WAREHOUSE(this.filter)
  },
  methods: {
    ...mapActions('obectsWarehouse', ['FETCH_WAREHOUSE']),

    search(text) {
      this.filter.search = text
      this.FETCH_WAREHOUSE(this.filter)
    },
    
    onFiltered() {
      this.FETCH_WAREHOUSE(this.filter)
    },
    onRowClicked() {
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#user-table {
  border-collapse: separate;
  border-spacing: 0 1rem;
}

#user-table .tableRowClass {
  background: white;
  transform: translateY(5px);
  transition: all 0.5s ease-in-out;
  text-align: center;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

  td {
    border-top: 0;
    padding: 20px !important;

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}

#user-table .tableRowClass:hover {
  transform: translateY(0);
}

#user-table .tableHeadClass {
  background: none !important;
  border: none !important;
}

#user-table .tableRowClass:hover {
  .tableTitle {
    color: #7367F0 !important;
  }
}

.tableHeadClass {
  text-align: center;
  padding-left: 0 !important;
}
</style>
